<template>
    <div class="alert drop-shadow" :class="{show : message}">
        <div class="text">{{messageDisplay}}</div>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        components: {},
        data: function() {
            return {
                show: false,
                timeout: null,
                messageDisplay: null
            };
        },
        computed: {
            message() {
                return this.$store.state.alert.message;
            },
            displayTime() {
                if (this.$store.state.alert.long) {
                    return 5000;
                } else {
                    return 3000;
                }
            }
        },
        watch: {
            message() {
                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
                if (this.message) {
                    this.messageDisplay = this.message;
                    this.show = true;
                    this.timeout = setTimeout(() => {
                        this.$store.dispatch('closeAlert')
                    }, this.displayTime);
                } else {
                    this.show = false;
                    this.timeout = setTimeout(() => {
                        this.messageDisplay = null;
                    }, 500);
                }
            }
        },
        methods: {

        }
    };
</script>

<style scoped>
    
    .alert {background-color: #C3D9EE; border: 1px solid #808080; padding: 1rem; width: 90vw; max-width: 20rem; text-align: center; position: fixed; left: 0; right: 0; margin: auto; box-sizing: border-box; transition: .5s; opacity: 0; bottom: -25vh;}
    .alert.show {bottom: 1rem; opacity: 1;}

</style>